import styled from "styled-components";

export const StyledGroupHeader = styled.div`
  display: flex;
`;

export const StyledGroupList = styled.div`
  display: flex;
`;

export const StyledButtonArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  gap: 1rem;
`;
